import { BadgeCheckIcon, Chrome, Copy, Send, Share } from "lucide-react";
import { ContentLayout } from "../../components/admin-panel/content-layout";
import React, { useContext, useEffect, useRef, useState } from "react";
import Loader from "../../assets/images/loader/loader-one.gif";
import { useDispatch, useSelector } from "react-redux";
import { toastError } from "../../components/ToastNotification";
import ChatService from "../../services/chat/chat";
import { useFormik } from "formik";
import { Avatar, AvatarImage } from "../../components/ui/avatar";
import { setInitial, setSubmitted } from "../../store/slices/chatSlice";
import Logo from "../../assets/images/Frame 2.svg";
import LogoNotFound from "../../assets/images/users.jpg";
import { ChatContext } from "../../context/chatContext";
import copy from "copy-to-clipboard";
import ReactMarkdown from "react-markdown";
import DOMPurify from "dompurify";
import { useNavigate } from "react-router";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../components/ui/dialog";
import { Button } from "../../components/ui/button";

const renderContent = (content) => {
  // Example: Check if content includes markdown or HTML
  if (content.includes("**") || content.includes("# ")) {
    // Render as Markdown
    return <ReactMarkdown>{content}</ReactMarkdown>;
  } else if (content.includes("<") && content.includes(">")) {
    // Sanitize and render as HTML
    const sanitizedHtml = DOMPurify.sanitize(content);
    return <div dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />;
  } else {
    // Render as plain text
    return <p>{content}</p>;
  }
};

const Homes = () => {
  const dispatch = useDispatch();
  const messageEndRef = useRef(null);
  const navigate = useNavigate();

  const { setIsSubmtted } = useContext(ChatContext);
  const user = useSelector((state) => state?.user?.user);
  console.log("useraaaaa", user)
  const chat = useSelector((state) => state?.chat);
  const [selectedConversationType, setSelectedConversationType] =
    useState("Individual");
  const [conversationId, setConversationId] = useState("");
  const textareaRef = useRef(null);
  const [messages, setMessages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isInitial, setIsInitial] = useState(true);
  const [text, setText] = useState("Copy");
  const [copiedIndex, setCopiedIndex] = useState("");
  const [showExpiryPopup, setShowExpiryPopup] = useState(false);
  // const user= useSelector((state)=>state?.user?.user);

  const handleSubmit = async (values, { setSubmitting }) => {
    if (user?.users?.subscriptionPlan == "FREE") {
      setShowExpiryPopup(true);
      setSubmitting(false);
      return;
    }

    dispatch(setInitial(false));
    formik.resetForm();
    const newMessage = { type: "user", content: values?.message };
    setMessages((prev) => [...prev, newMessage]);

    try {
      setIsLoading(true);

      const searchParams = new URLSearchParams(window.location.search);
      let currentConversationId = searchParams.get("conversationId")?.trim();

      if (!currentConversationId) {
        currentConversationId = await getConversationType();

        if (!currentConversationId) {
          return;
        }

        searchParams.set("conversationId", currentConversationId);
        navigate(`/home?${searchParams.toString()}`, { replace: true });
      }

      const response = await ChatService?.createChat(
        currentConversationId,
        user?.company?._id,
        user?.users?.category,
        values?.message,
        user?.users?.tenantId
      );
      if (response?.data?.data) {
        setIsLoading(false);
        const botResponse = {
          type: "bot",
          content: response?.data?.data?.output,
        };
        setIsSubmtted(true);
        setMessages((prev) => [...prev, botResponse]);
      }
    } catch (error) {
      toastError(error?.response?.data?.message);
    } finally {
      setSubmitting(false);
      setIsLoading(false);
      setIsInitial(false);
    }
  };

  // Formik setup
  const formik = useFormik({
    initialValues: {
      message: "",
    },
    onSubmit: handleSubmit,
  });

  const getConversationType = async () => {
    try {
      const response = await ChatService?.getConversationType(
        user?.users?.userType
      );
      const fetchedConversationId = response?.data?.data?._id;
      if (fetchedConversationId) {
        setConversationId(fetchedConversationId);
        return fetchedConversationId;
      }
      return "";
    } catch (error) {
      toastError(error?.response?.data?.message);
      return "";
    }
  };

  const handleCopyClick = (text, index) => {
    setCopiedIndex(index);
    copy(text);
    setText("Copied");
    setTimeout(() => {
      setText("Copy");
      setCopiedIndex("");
    }, 1000);
  };

  useEffect(() => {
    setInitial(chat?.isInitial);
  }, [chat?.conversationId]);

  useEffect(() => {
    if (chat?.isInitial) {
      setMessages([]);
    }
  }, [chat?.isInitial]);

  useEffect(() => {
    if (messageEndRef.current) {
      messageEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages]);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [formik.values.message]);

  useEffect(() => {
    if (chat?.chat) {
      setIsInitial(false);
      dispatch(setInitial(false));
      setConversationId(chat?.conversationId);
      const allMessages = chat?.chat?.flatMap((res) => [
        { type: "bot", content: res?.answer || "" },
        { type: "user", content: res?.question || "" },
      ]);
      setMessages(allMessages.reverse());
      // setMessages(allMessages);
    }
  }, [chat]);

  useEffect(() => {
    if (!chat?.conversationId) {
      // getConversationType();
    }
  }, [chat.conversationId]);

  return (
    <ContentLayout>
      <div>
        <div className="h-full relative min-h-[calc(100vh-204px)]">
          <div className="max-w-2xl mx-auto ">
            {chat?.isInitial && (
              <>
                <h1 className="user-name capitalize">
                  Hello {user?.users?.name}
                </h1>
                <h1 className="text-5xl font-semibold mt-2 !text-gray-600">
                  How can I help you today?
                </h1>
              </>
            )}
            {!chat?.isInitial && (
              <div className="grid gap-5">
                {/* GuideproAI Ans Box */}
                {messages?.map((res, index) => (
                  <div
                    key={index}
                    className={`bg-darkGray rounded-lg overflow-hidden relative tab:w-[calc(100%-100px)] ${res?.type === "bot"
                      ? "before-shadow ps-4 pt-5 pr-1 pb-1"
                      : "ms-auto p-4"
                      }`}
                  >
                    <div
                      className={`flex gap-3 items-start ${res?.type === "bot"
                        ? "text-left"
                        : "flex-row-reverse text-right"
                        }`}
                    >
                      {res?.type === "bot" ? (
                        <div className="h-7 w-7 flex justify-center cursor-pointer overflow-hidden rounded-full">
                          {/* <Chrome className="text-[#7376aa]" /> */}
                          <img src={Logo} alt="" />
                        </div>
                      ) : (
                        <div className="h-7 w-7 rounded-full overflow-hidden">
                          {user?.users?.profile ? (
                            <img src={user?.users?.profile} alt="@shadcn" />
                          ) : (
                            <img src={LogoNotFound} alt="User" />
                          )}
                        </div>
                      )}
                      <div className="w-[calc(100%-56px)] selection:bg-white selection:text-black">
                        {res?.type === "bot" ? (
                          <h5 className="font-semibold text-base mb-1">
                            GuideproAI
                          </h5>
                        ) : (
                          <h5 className="font-semibold text-base mb-1 capitalize">
                            {user?.users?.name}
                          </h5>
                        )}
                        <p className="text-[#7376aa]">
                          {renderContent(res?.content)}
                        </p>
                      </div>
                    </div>
                    {res?.type === "bot" ? (
                      <div className="flex items-center justify-end gap-1 mt-4">
                        {/* <div className="bg-body py-1.5 px-3 rounded flex items-center gap-2 text-white text-xs cursor-pointer">
                          <Share className="h-3 w-3" />
                          Share
                        </div> */}
                        <div
                          className="bg-body py-1.5 px-3 rounded flex items-center gap-2 text-white text-xs cursor-pointer"
                          onClick={() => handleCopyClick(res?.content, index)}
                        >
                          {index === copiedIndex && (
                            <BadgeCheckIcon className="h-3 w-3 text-primary" />
                          )}

                          {index === copiedIndex ? (
                            text
                          ) : (
                            <>
                              <Copy className="h-3 w-3" /> Copy
                            </>
                          )}
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                ))}

                <div ref={messageEndRef} />

                {isLoading && (
                  <div className="p-7 bg-[#0f1021] rounded-lg overflow-hidden relative before-shadow tab:w-[calc(100%-100px)]">
                    {/* Loader Content */}
                    <div className="flex gap-3 items-start">
                      <div className="flex items-center justify-center h-6 w-14">
                        <img src={Loader} alt="Loader" className="h-10 w-10" />
                      </div>
                      <p className="text-muted-foreground text-center">
                        Generating answers for you…
                      </p>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
        <div className="sticky bottom-0 pt-5 bg-body">
          <form onSubmit={formik.handleSubmit}>
            <div className="w-full max-w-2xl mx-auto">
              <div className="flex items-end bg-lightGray px-2 rounded-3xl">
                <div className="h-14 w-14 flex items-center justify-center cursor-pointer">
                  {/* <Chrome className="text-[#7376aa]" /> */}
                  <div className="rounded-full overflow-hidden  w-7 h-7">
                    <img src={Logo} alt="Logo" />
                  </div>
                </div>
                <textarea
                  ref={textareaRef}
                  className="search-input"
                  placeholder="Message GuideproAI...."
                  value={formik.values.message}
                  rows={1}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  name="message"
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && !e.shiftKey) {
                      e.preventDefault(); // Prevents adding a new line
                      formik.handleSubmit(); // Submits the form
                    }
                  }}
                />

                {formik.values.message && (
                  <div className="h-14 w-14 flex items-center justify-center">
                    <div className="p-2 flex items-center justify-center rounded-full bg-[#7064E9] cursor-pointer">
                      <button type="submit">
                        <Send size={20} />
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>
      <Dialog open={showExpiryPopup} onOpenChange={setShowExpiryPopup}>
        <DialogContent className="sm:max-w-md bg-[#070710] text-white border-neutral-800">
          <DialogHeader>
            <DialogTitle>Subscription Expired</DialogTitle>
          </DialogHeader>
          <div className="py-4">
            <p className="text-sm font-medium text-neutral-400">
              Your {user?.users?.userType === "IndividualUser" ? "Individual" : "Organization"} plan is expired, so please contact the
              {"  "} {user?.adminName}.
            </p>
          </div>
          <DialogFooter>
            <Button
              type="button"
              variant="outline"
              onClick={() => setShowExpiryPopup(false)}
              className="bg-primary border-0 hover:bg-btnHover  hover:text-white  text-white"
            >
              Close
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </ContentLayout>
  );
};

export default Homes;
